module.exports = __webpack_public_path__ + "static/media/water-drop-slash.23e8ec00.svg";